module.exports = __webpack_public_path__ + "img/customer_tag_1.3ae55b6b.webp";